import { AggregationType } from '@y42/json-schema';

export interface FieldAggregationModel {
  value: AggregationType | null;
  display_name: string;
  children?: FieldAggregationModel[];
}

export const AggregationTypesConstant: FieldAggregationModel[] = [
  {
    value: AggregationType.DayMonthYear,
    display_name: 'Date',
  },
  {
    value: AggregationType.DateHour,
    display_name: 'Date & Hour',
  },
  {
    value: AggregationType.DateMinute,
    display_name: 'Date & Min',
  },
  {
    value: AggregationType.Year,
    display_name: 'Year',
  },
  {
    value: AggregationType.QuarterYear,
    display_name: 'Year & Quarter',
  },
  {
    value: AggregationType.MonthYear,
    display_name: 'Year & Month',
  },
  {
    value: AggregationType.WeekNumberMonthYear,
    display_name: 'Year, Month & ISO Week',
  },
  {
    value: AggregationType.WeekMonthYear,
    display_name: 'Year, Month & Weekday',
  },
  {
    value: AggregationType.WeekNumberIsoYear,
    display_name: 'ISO Year & ISO Week',
  },
  {
    value: AggregationType.Quarter,
    display_name: 'Quarter',
  },
  {
    value: AggregationType.Month,
    display_name: 'Month',
  },
  {
    value: AggregationType.WeekMonth,
    display_name: 'Month & Weekday',
  },
  {
    value: AggregationType.WeekNumberMonth,
    display_name: 'Month & ISO Week',
  },
  {
    value: AggregationType.Week,
    display_name: 'Weekday',
  },
  {
    value: AggregationType.WeekNumber,
    display_name: 'ISO Week',
  },
  {
    value: AggregationType.Day,
    display_name: 'Day of Month',
  },
  {
    value: AggregationType.Hour,
    display_name: 'Hour',
  },
  {
    value: AggregationType.Value,
    display_name: 'VALUE',
  },
  {
    value: AggregationType.Sum,
    display_name: 'SUM',
  },
  {
    value: AggregationType.Avg,
    display_name: 'AVERAGE',
  },
  {
    value: AggregationType.Min,
    display_name: 'MINIMUM',
  },
  {
    value: AggregationType.Max,
    display_name: 'MAXIMUM',
  },
  {
    value: AggregationType.Count,
    display_name: 'COUNT',
  },
  {
    value: AggregationType.Distinct,
    display_name: 'DISTINCT COUNT',
  },
  /*{
		value: AggregationType.DISTRIBUTION,
		display_name: 'DISTRIBUTION'
	},*/
  {
    value: AggregationType.Calc,
    display_name: 'CALC',
  },
  {
    value: AggregationType.None,
    display_name: 'VALUE',
  },
];
